import { render, staticRenderFns } from "./navigationNotice.vue?vue&type=template&id=7202c840"
import script from "./navigationNotice.vue?vue&type=script&lang=js"
export * from "./navigationNotice.vue?vue&type=script&lang=js"
import style0 from "./navigationNotice.vue?vue&type=style&index=0&id=7202c840&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports